module.exports = __webpack_public_path__ + "static/media/prod7-bg.dec79273.png";